import { Droplets, Microscope, RefreshCw, Heart } from "lucide-react";

const features = [
  {
    icon: Droplets,
    title: "Leben retten",
    description:
      "Aus Ihrem Plasma werden Medikamente hergestellt, die Menschenleben retten und Patienten neue Hoffnung geben.",
  },
  {
    icon: Microscope,
    title: "Medikamente ermöglichen",
    description:
      "Plasma ist ein Ausgangsstoff für Arzneimittel wie Immunglobuline und Gerinnungsfaktoren.",
  },
  {
    icon: RefreshCw,
    title: "Regelmäßig möglich",
    description:
      "Bis zu 60 Spenden innerhalb von zwölf Monaten sind möglich. Die tatsächliche Häufigkeit hängt unter anderem von der individuellen Eignung und der Regeneration der Proteine ab.",
  },
  {
    icon: Heart,
    title: "Gutes tun und verdienen",
    description:
      "Retten Sie Leben und erhalten Sie gleichzeitig eine attraktive Aufwandsentschädigung.",
  },
];

const WhatIsPlasma = () => {
  return (
    <section
      className="section-screen bg-muted/30 scroll-mt-20 md:scroll-mt-0"
      id="wissen"
      aria-labelledby="plasma-heading"
    >
      <div className="container container-narrow">
        <h2
          id="plasma-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-5 font-display"
        >
          <span className="text-foreground">Was ist </span>
          <span className="text-gradient">Plasmaspenden</span>
          <span className="text-foreground">?</span>
        </h2>

        <div className="card-modern p-8 md:p-10 glow-primary">
          <p className="text-muted-foreground leading-relaxed mb-4 text-center max-w-3xl mx-auto text-lg">
            <strong className="text-foreground">Plasmaspenden</strong> ist ein
            medizinisch überwachtes Verfahren, bei dem der flüssige Teil Ihres
            Blutes, das sogenannte Blutplasma, entnommen wird. Anders als bei
            der klassischen Blutspende werden die festen Bestandteile wie rote
            Blutkörperchen direkt zurückgeführt.
          </p>

          <p className="text-muted-foreground leading-relaxed mb-8 text-center max-w-3xl mx-auto">
            Aus gespendetem Plasma werden Arzneimittel hergestellt, darunter
            Immunglobuline für Menschen mit Immundefekten und
            Gerinnungsfaktoren. Mit Ihrer Plasmaspende unterstützen Sie die
            Versorgung von Patientinnen und Patienten
            und erhalten dafür ca. 30 Euro pro Termin. Als Neuspender winken
            zusätzlich bis zu 150€ Anmeldebonus!
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 scroll-mt-24 md:scroll-mt-0">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center p-4"
              >
                <div className="w-14 h-14 rounded-2xl icon-glow flex items-center justify-center mb-4">
                  <feature.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="font-semibold text-foreground mb-2 text-lg">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsPlasma;
